module.exports = __webpack_public_path__ + "static/media/img4.aafd8c6b.jpg";